import $ from "jquery";

export function detect_touch() {

	function is_touch_device()
	{
		var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
		var mq = function(query) {
			return window.matchMedia(query).matches;
		}

		if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
			return true;
		}

		var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
		return mq(query);
	}

	if (is_touch_device())
	{
		$('body').addClass('touch-device');
	}

	var isAppleDevice = navigator.userAgent.match(/(iPod|iPhone|iPad)/) != null;

	if (isAppleDevice){
		$('body').addClass('ios');
    }

}



// WEBPACK FOOTER //
// ./resources/assets/js/modules/detect-touch.js